/* Built In Imports */
import { useRouter } from 'next/router';
import { useEffect } from 'react';

/* External Imports */
import { Box, Flex, Link } from '@chakra-ui/react';
import { nanoid } from 'nanoid';
import { useMediaQuery } from 'react-responsive';

/* Internal Imports */
/* Components */
import { isOpenInNewTab, refineUrlDomain } from '@ihs/components/Utility/utils';

/* Configs */
/* Styles */
/* Services */

/**
 *
 * @param {Object} menus
 * @returns
 */
const Sidebar = ({ menus }) => {
  const router = useRouter();
  const isMobile = useMediaQuery({ maxWidth: 767 });

  const scrollToView = () => {
    if (isMobile && typeof window !== 'undefined') {
      const menuItem = document.getElementById(
        router.asPath?.replace('/isha-home-school/', '')
      );
      // console.log('router.asPath', router.asPath?.replace('/isha-home-school/', ''))
      if (menuItem) {
        menuItem.scrollIntoView({
          block: 'nearest',
          inline: 'nearest',
          behavior: 'smooth',
        });
      }
    }
  };

  useEffect(() => {
    scrollToView();
  }, [router.asPath]);

  return (
    <Box
      as="aside"
      width={{ base: '100%', lg: '26.6%' }}
      h="100%"
      pt={{ base: '0', lg: '35px' }}
    >
      <Box
        as="nav"
        maxH="100%"
        width="100%"
        mx="auto"
        pl={{ base: '20px', lg: '80px' }}
        h={{ base: 'auto', lg: '100vh' }}
        pr={{ base: '20px', lg: '0' }}
      >
        <Flex
          borderLeft={{ base: 'none', lg: '1px solid #3B444B' }}
          borderBottom={{ base: '1px solid #3B444B', lg: 'none' }}
          py={{ base: '0', lg: '17px' }}
          flexDir={{ base: 'row', lg: 'column' }}
          maxH="100%"
          maxW="100%"
          overflow="auto"
          className="no-scrollbar"
        >
          {menus?.map(menu => {
            return (
              <Link
                id={menu?.url?.replace('/', '')}
                key={nanoid}
                py={{ base: '22px', lg: '14px' }}
                mr={{ base: '35px', md: '0' }}
                target={isOpenInNewTab(menu?.url) ? '_blank' : ''}
                borderLeft={{
                  base: 'none',
                  lg: menu?.url.includes(router.query.levelOne)
                    ? '8px solid #812C12'
                    : '8px solid transparent',
                }}
                pl={{ base: '13px', md: '20px', lg: '23px' }}
                pr={{ base: '13px', md: '0' }}
                borderBottom={{
                  base: menu?.url.includes(router.query.levelOne)
                    ? '4px solid #812C12'
                    : '8px solid transparent',
                  lg: 'none',
                }}
                cursor="pointer"
                color={
                  menu?.url.includes(router.query.levelOne)
                    ? '#812C12'
                    : '#3B444B'
                }
                w="auto"
                display="block"
                textDecor="none"
                _focus={{
                  textDecor: 'none',
                  color: '#812C12',
                  fontWeight: '700',
                }}
                _hover={{
                  textDecor: 'none',
                  color: '#812C12',
                  fontWeight: '700',
                }}
                _active={{
                  textDecor: 'none',
                  color: '#812C12',
                  fontWeight: '700',
                }}
                fontWeight={
                  menu?.url.includes(router.query.levelOne) ? 700 : 400
                }
                fontSize="20px"
                lineHeight="20px"
                minW={{ base: 'max-content', md: 'unset' }}
                style={{ minW: '-webkit-max-content' }}
                href={refineUrlDomain(menu?.url)}
              >
                {/* <NextLink 
                                key={key}
                                legacyBehavior 
                                href={refineUrlDomain(menu?.url)}
                            > */}
                {menu?.title}
                {/* </Box> */}
                {/* </NextLink> */}
              </Link>
            );
          })}
        </Flex>
      </Box>
    </Box>
  );
};

export default Sidebar;
